var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4367 11.1094H6.72337L14.9312 3.98438C15.0624 3.86953 14.9827 3.65625 14.8093 3.65625H12.7351C12.6437 3.65625 12.557 3.68906 12.489 3.74766L3.63196 11.4328C3.55084 11.5031 3.48579 11.5901 3.4412 11.6877C3.39661 11.7854 3.37354 11.8915 3.37354 11.9988C3.37354 12.1062 3.39661 12.2123 3.4412 12.3099C3.48579 12.4076 3.55084 12.4945 3.63196 12.5648L12.5406 20.2969C12.5757 20.3273 12.6179 20.3438 12.6624 20.3438H14.807C14.9804 20.3438 15.0601 20.1281 14.9288 20.0156L6.72337 12.8906H20.4367C20.5398 12.8906 20.6242 12.8062 20.6242 12.7031V11.2969C20.6242 11.1937 20.5398 11.1094 20.4367 11.1094Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallArrowLeft);
export default __webpack_public_path__ + "static/media/smallArrowLeft.03c66debd3ede90329238405be90db85.svg";
export { ForwardRef as ReactComponent };